import { render } from "./TabbedSlider.vue?vue&type=template&id=698b43b7&ts=true"
import script from "./TabbedSlider.vue?vue&type=script&lang=ts"
export * from "./TabbedSlider.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__